import { Head, Link } from '@inertiajs/react'
import { ArrowRight, CreditCard, LayoutGrid, Users } from 'lucide-react'
import AppLayout from '@/components/AppLayout'
import { Card } from '@/components/ui/Card'
import { PageHeader } from '@/components/shared'

interface HomeProps {
  app_name: string
}

const DESTINATIONS = [
  {
    href: '/overview',
    icon: LayoutGrid,
    label: 'Overview',
    blurb: 'Live health of the game across all regions.',
  },
  {
    href: '/players',
    icon: Users,
    label: 'Players',
    blurb: 'Search accounts, inspect a profile, suspend or ban.',
  },
  {
    href: '/cards',
    icon: CreditCard,
    label: 'Cards',
    blurb: 'The card catalogue and its artwork.',
  },
]

export default function Home({ app_name }: HomeProps) {
  return (
    <AppLayout>
      <Head title={app_name} />

      <PageHeader
        title="Dashboard"
        description="Jump into the part of the console you need."
      />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {DESTINATIONS.map(({ href, icon: Icon, label, blurb }) => (
          <Link
            key={href}
            href={href}
            className="focus-visible:outline-accent rounded-xl outline-none focus-visible:outline-2 focus-visible:outline-offset-2"
          >
            <Card className="group hover:border-border-strong h-full px-5 py-4 transition-colors duration-100 ease-out">
              <div className="flex items-center gap-2.5">
                <Icon aria-hidden className="text-fg-subtle size-4 shrink-0" />
                <span className="text-fg text-base font-semibold">{label}</span>
                <ArrowRight
                  aria-hidden
                  className="text-fg-subtle ml-auto size-4 shrink-0 transition-transform duration-100 ease-out group-hover:translate-x-0.5"
                />
              </div>
              <p className="text-fg-muted mt-1.5 mb-0 text-sm">{blurb}</p>
            </Card>
          </Link>
        ))}
      </div>
    </AppLayout>
  )
}
